import { ApplicationPageProps } from '../../Application';
import { ReferralSelection } from '../shared/ReferralSelection';

const RECKITT_REFERRAL_OPTIONS = [
	{ text: 'A colleague within your company', textValue: 'colleague' },
	{ text: 'Your manager', textValue: 'manager' },
	{ text: 'Your Global CSR leader', textValue: 'globalCSR' },
	{ text: 'Your Regional CSR leader', textValue: 'regionalCSR' },
	{ text: 'Email communication from your company', textValue: 'email' },
	{ text: 'Internal meeting or town hall', textValue: 'meeting' },
	{ text: 'LinkedIn', textValue: 'linkedin' },
	{ text: 'Other', textValue: 'other' },
];

export const ReckittReferralSelection = (props: ApplicationPageProps) => {
	return (
		<ReferralSelection
			{...props}
			referralOptions={RECKITT_REFERRAL_OPTIONS}
		/>
	);
};
